<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/fuente-Madin.webp',
                    '/pagesImages/salon-Madin-1.webp',
                    '/pagesImages/salon-Madin-2.webp',
                    '/pagesImages/salon-Madin-4.webp',
                    '/pagesImages/salon-Madin-5.webp',
                    '/pagesImages/salon-Madin-6.webp',
                    '/pagesImages/salon-Madin-7.webp',
                    '/pagesImages/pergola-madin.webp',
                ],
                images2: [
                    '/pagesImages/teatro-1.webp',
                    '/pagesImages/areas-verdes-madin-1.webp',
                    '/pagesImages/canchas.webp',
                    '/pagesImages/areas-verdes-madin-2.webp',
                    '/pagesImages/teatro-2.webp',
                    '/pagesImages/despierta-Madin.webp',
                    '/pagesImages/alumnos-Madin.webp',
                ],
                alts: [
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín',
                ],
                alts2: [
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín',
                    'Fotos de instalaciones de campus Presa Madín'
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Madin-1.webp",
                    "/pagesImages/encabezado-landing-Madin-2.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Presa Madin de día",
                    "Fotos de campus Magno Presa Madin de día",
                ],
                tour: [
                    { src:"/pagesImages/tour-Madin-1.webp", title:"Tour virtual de Campus Presa Madín"},
                    { src:"/pagesImages/tour-Madin-2.webp", title:"Tour virtual de Campus Presa Madín"},
                    { src:"/pagesImages/tour-Madin-3.webp", title:"Tour virtual de Campus Presa Madín"},
                    { src:"/pagesImages/tour-Madin-4.webp", title:"Tour virtual de Campus Presa Madín"},
                    { src:"/pagesImages/tour-Madin-5.webp", title:"Tour virtual de Campus Presa Madín"},
                    { src:"/pagesImages/tour-Madin-6.webp", title:"Tour virtual de Campus Presa Madín"},
                    { src:"/pagesImages/tour-Madin-7.webp", title:"Tour virtual de Campus Presa Madín"},
                ],
                campusName: "PRESA MADÍN",
                campusType: "CAMPUS MAGNO",
                localidad: "Estado de México",
                frase: "El único modo de hacer un gran trabajo es amar lo que haces",
                autor: "Steve Jobs",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Magno Madín'" :testo1="'Es un espacio donde la excelencia académica se refleja en el desarrollo integral de las habilidades intelectuales de los estudiantes, preparándolos para su futuro profesional.'" :testo2="'La Presa Madín, ubicada en el municipio de Atizapán, en el Estado de México, enmarca este Campus Magno de Universidad Humanitas, que en conjunto con la espectacular vista, crean un paisaje que inspira conocimientos y reflexión.'" :testo3="'Ofrece una amplia oferta académica, aulas especializadas y un cuerpo docente altamente capacitado, brindando a cada estudiante las herramientas necesarias para alcanzar su máximo potencial.'" :img="'/pagesImages/Una-mirada-Madin.webp'" :alt="'Fuente de campus presa Madín'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Diseñado para ofrecer una experiencia universitaria integral, donde la innovación académica, el aprendizaje de calidad y <br class="lg:block hidden"> las actividades recreativas se combinan en perfecta armonía.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras, la biblioteca fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Instalaciones especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Áreas equipadas para disciplinas como Psicología y Derecho, con herramientas especializadas para el desarrollo práctico de los estudiantes.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        :alt="alts[0]"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        :alt="alts2[0]"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8 order-1 lg:order-2">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Canchas y zonas recreativas que promueven un estilo de vida saludable, integrando deporte y bienestar en la rutina estudiantil.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Teatro Magno</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con capacidad para alrededor de 500 personas, este foro cuenta con butacas cómodas, camerinos y salas de ensayo, fomentando la difusión de las Bellas Artes y la cultura.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 mb-4 leading-none w-full">Oferta académica en<br class="lg:block hidden"> Campus Magno Humanitas</h2>
    <Oferta :Licenciaturas="'/pagesImages/licenciaturas-estructura.webp'" :Maestrias="'/pagesImages/estructura-academica-educacion.webp'" :Doctorados="'/pagesImages/modelo-ejecutivo-hombre.webp'" :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura' ],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Mercadotecnia', 'Contabilidad']
    }" class="flex items-center justify-center" />
    <!-- <Oferta :Licenciaturas="'/pagesImages/licenciaturas-estructura.webp'" :Maestrias="'/pagesImages/estructura-academica-educacion.webp'" :Doctorados="'/pagesImages/modelo-ejecutivo-hombre.webp'" :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura', 'Diseño Gráfico', 'Arte y Teatro'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Mercadotecnia Digital', 'Contabilidad', 'Educación'],
        Doctorados: ['Alta Dirección']
    }" class="flex items-center justify-center" /> -->

    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class="md:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/modelo-escolarizado-madin.webp" alt="Modelo Escolarizado" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo Escolarizado</span>
                                </h3>
                                <p class="md:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Presa Madín en nuestro tour virtual.</p>
            <Tour360 :src="'https://www.google.com/maps/embed?pb=!4v1560559333324!6m8!1m7!1sCAoSLEFGMVFpcFA5d0xidjZIYTBWZzdBX1JfRVdFcXpyaXJXcXFKcktEVkc4ekQ2!2m2!1d19.531325380478!2d-99.263745701945!3f138.85!4f9.11!5f0.7820865974627469'"  class="w-full mb-12"/>
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <Instalaciones :items="tour" class="" />
        </div>
    </div>
    <Ubicacion :campus="'Campus Magno Madín'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7520.492114723999!2d-99.263648!3d19.531047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21cb0eb704871%3A0xd6d88f92b654e1dd!2sUniversidad%20Humanitas%20Campus%20Presa%20Mad%C3%ADn!5e0!3m2!1ses!2smx!4v1738217853369!5m2!1ses!2smx'" :testo1="'El Campus está ubicado en una zona accesible desde la Ciudad de México, tanto en transporte público como en automóvil.'" :testo2="'Se puede llegar desde la estación de metro Cuatro Caminos en las rutas: 12, 18A, 18C, 25-01 y 8 o desde la Central del Norte en dirección hacia Lomas Verdes.'" :testo3="'En auto, la vía de acceso es por el Bulevar Periférico en dirección norte y la Supervía Lomas Verdes.'" :ubicacion="'Dirección: Camino Viejo a Madín 35-B Colonia Viejo Madín, Cd. López Mateos C.P. 52989 Estado de México.'" :telefono="'55 4774 89 90'" class="lg:px-0 px-8" />
	<!-- <BienvenidosCampus
		:frase="'El único modo de hacer un gran trabajo es amar lo que haces'"
		:autor="'Steve Jobs'"
		:line1="'Camino Viejo a Madín 38-B'"
		:line2="'Colonia Viejo Madín,'"
		:line3="'Cd. López Mateos'"
		:line4="'C.P. 52989'"
		:line5="'Estado de México'"
		:line6="''"
		:mapslink="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7520.492114723999!2d-99.263648!3d19.531047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21cb0eb704871%3A0xd6d88f92b654e1dd!2sUniversidad%20Humanitas%20Campus%20Presa%20Mad%C3%ADn!5e0!3m2!1ses!2smx!4v1738217853369!5m2!1ses!2smx'"
	/>

	<ModelosEducativos />

	<OfertaEducativa />

	<HumanitasMuchoMas /> -->
</template>

<style scoped>
</style>
